import { create } from 'zustand';
import { MutableRefObject } from 'react';
import { AuditInvitation } from '@/common';

type ModalState =
  | 'hidden'
  | 'confirm-audit-invitation'
  | 'deny-audit-invitation'
  | 'deny-statement';

type BrowsePageState = {
  modalState: ModalState;
  auditInvitation: AuditInvitation | null;
  browseViewRef: MutableRefObject<any> | null;
};

type BrowsePageActions = {
  setModalState: (modalState: ModalState) => void;
  setAuditInvitation: (auditInvitation: AuditInvitation | null) => void;
  setBrowseViewRef: (browseViewRef: MutableRefObject<any> | null) => void;
};

export const useBrowsePageStore = create<BrowsePageState & BrowsePageActions>((set) => ({
  modalState: 'hidden',
  auditInvitation: null,
  browseViewRef: null,

  setModalState: (modalState: ModalState) => set({ modalState }),
  setAuditInvitation: (auditInvitation: AuditInvitation | null) => set({ auditInvitation }),
  setBrowseViewRef: (browseViewRef: MutableRefObject<any> | null) => set({ browseViewRef }),
}));
